import DynamicMap from './DynamicMap';

export default DynamicMap;
